import Vue from "vue";

export default {
  loadVideo(state, {id, zIndex}) {
    const video = state.videos.items[ id ];

    if(! video) {
      console.error('Unable to load Video ID, the video was not found');
      return;
    }

    Vue.set(state.videos.videoQueue, parseInt( id ), {
      zIndex,
      status: 'loading'
    });
  },
  /** Remove a video from the queue once current one is loaded */
  removeVideoFromQueue(state, id){
    Vue.delete(state.videos.videoQueue, id);
  },
  /** Finds the id in the video queue and sets the status to ready */
  setVideoReady(state, id){
    Vue.set( state.videos.videoQueue[ id ], 'status', 'ready' );
    state.videos.active = id;
  },
}